module.exports = __webpack_public_path__ + "img/auto-plus_article.b3e01beb.jpeg";